import { useContext, useEffect } from "react"
import intl from "react-intl-universal"

import useDataApi from "../../../hooks/useDataApi"
import { fnGetBoardInteractions } from "../../../services/boards"
import { fnFormatDate, fnFormatDateFromUTC } from "../../../utils/date"
import RcmpModalInteractions from "../../molecules/ModalInteractions"
import AuthContext from "../../../contexts/Auth"
import moment from "moment"

export default function RcmpBoardInteractions(props) {
  const { bOpenInteractions, oSelectedBoard, fnSetBOpenInteractions } = props

  const [oBoardInteractionsRes, fnGetBoardInterationsReq] = useDataApi(
    fnGetBoardInteractions
  )

  useEffect(() => {
    if (
      oBoardInteractionsRes.loading ||
      !bOpenInteractions ||
      !oSelectedBoard?.id
    )
      return
    (async () => {
      await fnGetBoardInterationsReq(oSelectedBoard?.id)
    })()
  }, [bOpenInteractions, oSelectedBoard])

  function fnCloseModalInteractions() {
    fnSetBOpenInteractions(false)
  }
  const { oUser } = useContext(AuthContext)
  const cUserTimezone = oUser?.data?.user_ctimezone || "America/Sao_Paulo"
  const cErrorMessage = oBoardInteractionsRes?.error
    ? intl.get("board.interactions_error") : null

  const aInteractions = oBoardInteractionsRes?.data?.data?.map((i, index) => {
    return {
      opae_cvalue: i?.description,
      cUserName: i?.user?.user_cname,
      dDate: i?.created_at,
    }
  })

  return (
    <RcmpModalInteractions
      bIsOpen={bOpenInteractions}
      fnOnClose={fnCloseModalInteractions}
      cTitle={`${oSelectedBoard?.name} - ${intl.get("board.interactions")}`}
      aInteractions={aInteractions}
      bLoading={oBoardInteractionsRes.loading}
      cErrorMessage={cErrorMessage}
    />
  )
}
